import { createLogic, createLogicMiddleware } from 'redux-logic'
import Cookies from 'js-cookie'

import { parseJwtToken, getLoginURL } from '../api/login'

import { saveTokenDetails } from '../actions/login'
import { routeToOnDemand, routeToInstalledAgent } from '../actions/routing'
import { NETOP_PORTAL_ENVIRONMENT } from '../api/env'

export const checkLoggedInLogic = createLogic({
  type: [routeToOnDemand, routeToInstalledAgent],

  process ({ setWindowLocation, parseJwtToken, Cookies, getLoginURL }, dispatch, done) {
    const jwtToken = Cookies.get(`nrctkn_${NETOP_PORTAL_ENVIRONMENT}`)
    if (jwtToken) {
      const { token, userId, accountId = null } = parseJwtToken(jwtToken)
      dispatch(saveTokenDetails({ token, userId, accountId }))
    } else {
      setWindowLocation(getLoginURL(window.location.href))
    }
    done()
  }
})

const arrLogic = [checkLoggedInLogic]

const deps = {
  setWindowLocation: (url) => { window.location = url },
  parseJwtToken,
  Cookies,
  getLoginURL
}
export const loginLogicMiddleware = createLogicMiddleware(arrLogic, deps)
